import styled from 'styled-components';
import {Drawer} from "antd";
import {
    DARK_MODE_BORDER,
    DARK_MODE_COMMON_TEXT_COLOR,
    DARK_MODE_HEADER_BACKGROUND
} from "../../../../constants/colorScheme";

const StyledDrawer = styled(Drawer)`
    .site-description-item-profile-wrapper {
        display: flex;
    }
    .software-product-tag {
        background: ${props => props.darkMode && DARK_MODE_HEADER_BACKGROUND};
        color: ${props => props.darkMode && DARK_MODE_COMMON_TEXT_COLOR};
        border: ${props => props.darkMode && DARK_MODE_BORDER};
    }
    .ant-divider {
        color: ${props => props.darkMode && DARK_MODE_COMMON_TEXT_COLOR};        
        border-color: ${props => props.darkMode && DARK_MODE_COMMON_TEXT_COLOR};        
    }
`;

export default StyledDrawer;